import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes } from "react-icons/fa";
import failimg from "../../../assets/images/fail.png";
const FailDialog = ({ open, closeFailDialog, msg }) => {
  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={open}
      onClose={closeFailDialog}
      maxWidth="sm"
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                closeFailDialog(false);
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="clear10"></div>
        <div className="row">
          <div className="col-12 text-center">
            <img src={failimg} alt="success" className="successimg-new"></img>
            <p className="fs-20 semi-bold text-center">{msg}</p>
            <div className="clear10"></div>
          </div>
          <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
            <button
              type="button"
              class="donebtn canBtn"
              onClick={(event) => {
                event.stopPropagation();
                closeFailDialog(false);
              }}
            >
              Ok
            </button>
          </div>
        </div>

        <div className="clear10"></div>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default FailDialog;
